/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-types */
import { DoneInvokeEvent, EventObject, InvokeCreator, Actions } from "xstate";

export type DeleteDialogTypeState<TContext, TKey extends string> =
    // eslint-disable-next-line prettier/prettier
    | { value: `${TKey}.closed`; context: TContext }
    | { value: `${TKey}.open`; context: TContext }
    | { value: `${TKey}.deleting`; context: TContext };

/**
 * Embeds a reusable machine state node, useful for any machines involving delete confirmation dialogs
 * @param deleteAsyncCallback api call to delete entity
 * @param onDoneAction called after successful deletion
 * @param onDoneTarget target state after successful deletion
 * @param onErrorTarget target state after unsuccessful deletion
 */
export const deleteDialogMachineConfig = <TContext, TData, TEvents extends EventObject = any>(
    deleteAsyncCallback: string | InvokeCreator<TContext, TEvents>,
    onDoneAction: string | Actions<TContext, DoneInvokeEvent<TData>>,
    onDoneTarget: string,
    onErrorTarget: string
) => ({
    initial: "closed",
    states: {
        closed: {
            id: "closed",
            on: { DELETE: "open" },
        },
        open: {
            on: {
                CONFIRM_DELETE: "deleting",
                CANCEL_DELETE: "closed",
            },
        },
        deleting: {
            invoke: {
                src: deleteAsyncCallback,
                onDone: {
                    target: onDoneTarget,
                    actions: onDoneAction,
                },
                onError: onErrorTarget,
            },
        },
    },
} as const);
